import { render, staticRenderFns } from "./DetailedAccounts.vue?vue&type=template&id=deb8f51e&scoped=true"
import script from "./DetailedAccounts.vue?vue&type=script&lang=js"
export * from "./DetailedAccounts.vue?vue&type=script&lang=js"
import style0 from "./DetailedAccounts.vue?vue&type=style&index=0&id=deb8f51e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb8f51e",
  null
  
)

export default component.exports